module.exports = __webpack_public_path__ + "img/security.f443469f.svg";